<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.season.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <!-- <div class="app-content-create">
      <router-link :to="{ path: '/season/new' }" v-if="hasPermissionToCreate">
        <el-button class="app-content-create-button" type="primary">
          <app-i18n code="entities.season.new.title" />
        </el-button>
      </router-link>
    </div> -->

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.season.list.title"></app-i18n>
      </h1>

      <app-season-list-toolbar></app-season-list-toolbar>
      <app-season-list-filter></app-season-list-filter>
      <app-season-list-table></app-season-list-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CategoryPermissions } from '@modules/category/category-permissions';

import SeasonListFilter from '@modules/season/components/season-list-filter.vue';
import SeasonListTable from '@modules/season/components/season-list-table.vue';
import SeasonListToolbar from '@modules/season/components/season-list-toolbar.vue';

export default {
  name: 'app-season-list-page',

  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),

    hasPermissionToCreate() {
      return new CategoryPermissions(this.currentUser)
        .create;
    },
  },

  components: {
    [SeasonListFilter.name]: SeasonListFilter,
    [SeasonListTable.name]: SeasonListTable,
    [SeasonListToolbar.name]: SeasonListToolbar,
  },
};
</script>

<style>
</style>
